/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentMediaGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Media Group API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Archetact ]
 *  
 *  Created:    Thursday, January 16, 2025 - 12:41 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/16/2025  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2025 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from "./requests";

export const MediaGroups = {
  all: () => requests.postLambda("/mediaGroups", {
    action: "getMediaGroups",
    parameters: {
      companyid: 10000,
      order: "NAME DESC"
    }
  }),
  get: mediagroupid => requests.postLambda("/mediaGroups", {
    action: "getMediaGroup",
    parameters: {
      companyid: 10000,
      mediagroupid: mediagroupid
    }
  }),
  create: (name, description) => requests.postLambda("/mediaGroups", {
    action: "createMediaGroup",
    parameters: {
      companyid: 10000,
      name: name,
      description: description
    }
  }),
  update: (mediagroupid, name, description) => requests.postLambda("/mediaGroups", {
    action: "editMediaGroup",
    parameters: {
      companyid: 10000,
      mediagroupid: mediagroupid,
      name: name,
      description: description
    }
  }),
  delete: mediagroupid => requests.postLambda("/mediaGroups", {
    action: "deleteMediaGroup",
    parameters: {
      companyid: 10000,
      mediagroupid: mediagroupid
    }
  }),
};